import { Box, HStack, Text } from '@chakra-ui/react'
import React from 'react'
import { Link, useMatch } from 'react-router-dom'

const RouteSidebarLink = ({ name, path, icon, defaultBackgroundColor, indent }) => {
  const selected = useMatch(path)

  return (
    <Link to={path} style={{ textDecoration: 'none' }}>
      <Box
        ml={indent}
        px={5}
        py={3}
        _hover={{ bg: 'teal.600', cursor: 'pointer', color: 'white' }}
        bg={selected ? 'teal.600' : defaultBackgroundColor}
        color={selected ? 'white' : ''}
      >
        <HStack>
          {icon}
          <Text fontSize="md">{name}</Text>
        </HStack>
      </Box>
    </Link>
  )
}

// `indent` is a margin, so the item's background is indented with its text.
const SidebarLink = ({ name, path, icon, onClick, defaultBackgroundColor = 'teal.500', indent = 0 }) => {
  if (path) {
    return (
      <RouteSidebarLink
        name={name}
        path={path}
        icon={icon}
        defaultBackgroundColor={defaultBackgroundColor}
        indent={indent}
      />
    )
  } else {
    const selected = ''
    return (
      <Link style={{ textDecoration: 'none' }} onClick={onClick}>
        <Box
          ml={indent}
          px={5}
          py={3}
          _hover={{ bg: 'teal.600', cursor: 'pointer', color: 'white' }}
          bg={selected ? 'teal.600' : ''}
          color={selected ? 'white' : ''}
        >
          <HStack>
            {icon}
            <Text fontSize="md">{name}</Text>
          </HStack>
        </Box>
      </Link>
    )
  }
}

export default SidebarLink
